import { useContext } from "react"
import { GlobalContext } from "../Context/globalContext"
import { Footer } from "./footer";
import { Header } from "./header";

export const Layout = (props) => {

    const globalContext = useContext(GlobalContext);

    return (
        <>
            {globalContext.loggedIn ?
                <>
                    <Header />
                    {props.children}
                    <Footer />
                </>
                :
                <>
                    {props.children}
                </>
            }
        </>
    )

}